// custom components
import DAlert from './DAlert.vue';
import DBankID from './DBankID.vue';
import DBubbles from './DBubbles.vue';
import DButton from './/DButton.vue';
import DCallout from './DCallout.vue';
import DCard from './DCard.vue';
import DChart from './DChart.vue';
import DCol from './DCol.vue';
import DCookie from './DCookie.vue';
import DHelp from './DHelp.vue';
import DModal from './DModal.vue';
import DModalTrigger from './DModalTrigger.vue';
import DImage from './DImage.vue';
import DInputSelect from './Form/DInputSelect.vue';
import DInputText from './Form/DInputText.vue';
import DInputSwitch from './Form/DInputSwitch.vue';
import DLoader from './DLoader.vue';
import DMarkup from './DMarkup.vue';
import DOverflow from './Overflow/DOverflow.vue'
import DPage from './DPage.vue';
import DPageHeader from './Page/DPageHeader.vue';
import DPageCard from './Page/DPageCard.vue';
import DQRViewer from './DQRViewer.vue';
import DReport from './DReport.vue';
import DRow from './DRow.vue';
import DSkeleton from './DSkeleton.vue';
import DSVG from './DSVG.vue';
import DText from './DText.vue';
import DUpload from './DUpload.vue';
import DDocumentViewer from './DocumentViewer/DDocumentViewer.vue';

export function initcomponents(app)
{
    app.component("DAlert", DAlert)
    .component("DBankid", DBankID)
    .component("DBubbles", DBubbles)
    .component("DButton", DButton)
    .component("DCallout", DCallout)
    .component("DCard", DCard)
    .component("DChart", DChart)
    .component("DDocumentViewer", DDocumentViewer)
    .component("DHelp", DHelp)
    .component("DImage", DImage)
    .component("DInputSelect", DInputSelect)
    .component("DInputText", DInputText)
    .component("DInputSwitch", DInputSwitch)
    .component("DLoader", DLoader)
    .component("DMarkup", DMarkup)
    .component("DModal", DModal)
    .component("DModalTrigger", DModalTrigger)
    .component("DCol", DCol)
    .component("DCookie", DCookie)
    .component("DOverflow", DOverflow)
    .component("DPage", DPage)
    .component("DPageHeader", DPageHeader)
    .component("DPageCard", DPageCard)
    .component("DQrViewer", DQRViewer)
    .component("DReport", DReport)
    .component("DRow", DRow)
    .component("DSkeleton", DSkeleton)
    .component("DSvg", DSVG)
    .component("DText", DText)
    .component("DUpload", DUpload);
}